var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_10286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40625 6.35156V12H10.2188C10.8003 12 11.2969 11.5269 11.2969 10.9453V6.35156H7.40625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 6.35156V10.9453C0.703125 11.5269 1.17623 12 1.75781 12H4.59375V6.35156H0.703125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 2.8125H9.50665C9.72973 2.5178 9.86719 2.15503 9.86719 1.75781C9.86719 0.788602 9.07859 0 8.10938 0C6.88259 0 6.52739 0.883711 6 2.22195C5.47261 0.883711 5.11741 0 3.89062 0C2.92141 0 2.13281 0.788602 2.13281 1.75781C2.13281 2.15503 2.27027 2.5178 2.49335 2.8125H1.05469C0.473109 2.8125 0 3.28561 0 3.86719V4.59375C0 5.17533 0.473109 5.64844 1.05469 5.64844H4.59375V2.8125H3.89062C3.30905 2.8125 2.83594 2.33939 2.83594 1.75781C2.83594 1.17623 3.30905 0.703125 3.89062 0.703125C4.61126 0.703125 4.81622 1.13536 5.35491 2.50214C5.39245 2.59758 5.43928 2.7108 5.47976 2.8125H5.29688C5.29688 8.05505 5.29688 6.75513 5.29688 12H6.70312C6.70312 3.77072 6.70312 5.09812 6.70312 2.8125H6.52027C6.56074 2.71078 6.60755 2.59758 6.64512 2.50214C7.18378 1.13536 7.38874 0.703125 8.10938 0.703125C8.69095 0.703125 9.16406 1.17623 9.16406 1.75781C9.16406 2.33939 8.69095 2.8125 8.10938 2.8125H7.40625V5.64844H10.9453C11.5269 5.64844 12 5.17533 12 4.59375V3.86719C12 3.28561 11.5269 2.8125 10.9453 2.8125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_10286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.247cc1d290c62bf3e170a706d7a6c35f.svg";
export { ForwardRef as ReactComponent };